import {IMuWidget} from "./IMuWidget";
import {SearchSelector} from "./SearchSelector";
import {InvoiceApprovalCL} from "./generated/InvoiceApprovalCL";
import {ApprovingSchemaEditorCL} from "./generated/ApprovingSchemaEditorCL";
import {changeElementOrder, indexBy, isOpenInNew} from "./Utils";
import {UiFlashMessage} from "./UiFlashMessage";
import {TreeSelector} from "./TreeSelector";
import {Account} from "./CommonTypes";
import {ApprovingSchema} from "./InvoiceTypes";
import {MuRouter, MuRouterContext} from "mu-widget/lib/MuRouter";

export class ApprovingSchemas extends IMuWidget {

	public cl: ApprovingSchemaEditorCL;

	public orgDivisions: any;

	public clUrl: string;

	public router: MuRouter;

	public baseUrl: string;

	beforeIndex() {
		this.cl = new ApprovingSchemaEditorCL(this.clUrl);
	}

	afterIndex() {
		// this.openList();
		this.container.classList.remove('loading');
		this.openTry(false);

		const r = this.router = new MuRouter();
		r.pathPrefix = this.baseUrl;
		r.addRoute('edit', '/edit/<id>', (rc: MuRouterContext) => this.openEditor(rc.parameters.id as string));
		r.addRoute('try', '/try/<id>', (rc: MuRouterContext) => this.openTry(rc.parameters.id as string));
		r.addRoute('list', '', (rc: MuRouterContext) => this.openList());

		r.route();
	}

	public openList() {
		this.cl.getApprovingSchemaList(true, null).then(list => this.muBindData({approvingSchemaList: list}));
		this.showPart('list');
	}

	static readonly draftPrefix = "draft:";

	public openEditor(id : number|null|string) {
		if (id)
		{
			if (typeof id === "string" && !id.startsWith(ApprovingSchemas.draftPrefix)) id = parseInt(id);
			this.cl.getApprovingSchema(id, true).then(data => {
				this.muNamedWidget.editor.muBindData({ ...data, id: id});
				this.showPart('editor');
			});
		} else {
			this.muNamedWidget.editor.muBindData({
				name: '',
				steps: [ { groups:[{minimalApprovers:"1",organizationApprovers:[],approvers:[] } ] } ]
			});
			this.showPart('editor');
		}
	}

	bAddNew_click() {
		// this.openEditor(null);
		this.router.navigate('edit', {id: null});
	}

	private showPart(part: string) {
		for(let p of ['list', 'editor']) {
			this.muVisible(part === p, 'p_' + p);
		}
	}

	openTry(id: number|string|false|ApprovingSchema) {
		if (id !== false)
		{
			switch (typeof id) {
				case 'string':
					if (!id.startsWith(ApprovingSchemas.draftPrefix)) id = parseInt(id);
				case 'number':
					this.cl.getApprovingSchema(id, true).then(
						data => (this.muNamedWidget.approvingSchemaTry as ApprovingSchemaTry).bindSchema(data)
					);
					break;
				case 'object':
					(this.muNamedWidget.approvingSchemaTry as ApprovingSchemaTry).bindSchema(id);
					break;
			}
		}
		this.muVisible(!!id, "approvingSchemaTry");
	}
}

export class ApprovingSchemaEditor extends IMuWidget {
	id : number;

	originalId: number|null = null;

	isDraft : boolean;
	private isNew: boolean;

	muParent : ApprovingSchemas;

	public orgDivisions: any;

	public cl: ApprovingSchemaEditorCL;

	muBindData(srcData: any) {
		super.muBindData(srcData);
		const id = srcData["id"];
		this.isNew = !id;
		this.isDraft = typeof id === "string" && id.startsWith(ApprovingSchemas.draftPrefix);
		this.id = this.isDraft
			? parseInt(id.substr(6))
			: id;
		this.originalId = srcData.originalId || null;
		this.ui.bSaveDraft.innerText = this.isDraft ? 'Uložit koncept' : 'Uložit jako nový koncept';
		this.muVisible(this.isDraft, "bSave");
		this.muVisible(!!this.originalId, ["bSaveReplace", "linkOriginal"]);
		if (!!this.originalId) {
			this.ui.linkOriginal.href = this.muParent.router.makeUrl("edit", {id: this.originalId.toString()})
		}
		this.ui.category.innerText = this.isNew
			? "Nové schvalovací schéma"
			: (this.isDraft
				? "Koncept schvalovacího schématu"
				: "Aktivní schvalovací schéma"
			);
	}

	linkOriginal_click() {
		this.muParent.router.navigate("edit", {id: this.originalId.toString()})
	}

	public bAdd_click() {
		this.muWidgetFromTemplate("step", "steps").muBindData({});
	}

	public async afterIndex() {
		this.cl = this.muParent.cl;
	}

	async bSave_click() {
		await this.cl.saveApprovingSchema(
			this.muFetchData(),
			false,
			null,
			null
		);
		UiFlashMessage.instance.add("Bylo vytvořeno nové schvalovací schéma");
		this.muParent.router.navigate("list");
		// this.muParent.openList();
	}

	async bSaveReplace_click() {
		await this.cl.saveApprovingSchema(
			this.muFetchData(),
			false,
			null,
			this.originalId
		);
		UiFlashMessage.instance.add("Bylo vytvořeno nahrazeno původní schvalovací schéma");
		this.muParent.router.navigate("list");
		// this.muParent.openList();
	}

	async bSaveDraft_click() {
		const data = this.muFetchData();
		if (!this.isDraft) data.originalId = this.id;
		await this.cl.saveApprovingSchema(
			data,
			true,
			this.isDraft ? this.id : null,
			null
		);
		UiFlashMessage.instance.add("Schvalovací schéma bylo uloženo jako " + (this.isDraft ? "" : " nový ") + "koncept");
		// this.muParent.openList();
		this.muParent.router.navigate("list");
	}

	bCancel_click() {
		if (confirm("Opravdu mám zavřít editor bez uložení změn?"))
			this.muParent.router.navigate("list");
			// this.muParent.openList();
	}

	bTry_click() {
		this.muParent.openTry(this.muFetchData());
	}
}

export class ApprovingSchemaEditorStep extends IMuWidget {
	public cl: ApprovingSchemaEditorCL;
	protected muAfterBindData(data) {
		super.muAfterBindData(data);
		// this.name_blur();
		this.cl = (this.muParent as ApprovingSchemaEditor).cl;
	}

	/* public noname_click() {
		this.muVisible(false, "noname");
		this.ui.name.focus();
	}

	public name_keyup() { this.name_blur(); }

	public name_blur() {
		this.muVisible(!this.ui.name.innerText.trim(), "noname");
	} */

	public bAdd_click() {
		this.muWidgetFromTemplate("item", "items").muBindData({ minApprovers: 1 });
	}

	public bRemove_click() {
		const n = this.ui.name.innerText.trim();
		if (confirm("Opravdu chcete odebrat " + (n ? "kolo " + n : "toto kolo") + "?")) this.muRemoveSelf();
	}

	public bUp_click() {
		changeElementOrder(this.container, -1);
	}

	public bDown_click() {
		changeElementOrder(this.container, 1);
	}
}

export class ApprovingSchemaEditorGroup extends IMuWidget {

	private cl: ApprovingSchemaEditorCL;

	public afterIndex() {
		this.cl = (this.muParent.muParent as ApprovingSchemaEditor).cl;
		(this.muNamedWidget.accountSelector as SearchSelector).searchCallback =
			(term, resolve) => this.cl.findAccounts(term).then(data => resolve(data));
		(this.muNamedWidget.orgRoleSelector as SearchSelector).searchCallback =
			(term, resolve) => this.cl.findOrgRoles(term).then(data => resolve(data));
		//todo: retype
		setTimeout(() => (this.muNamedWidget.orgDivisionSelector as any).reload((this.muParent.muParent as ApprovingSchemaEditor).orgDivisions), 0);
		this.useOtherOrgDivision_change();
	}

	protected muAfterBindData(data: any) {
		// super.muAfterBindData(data);
		// this.name_blur();
	}

	/* public noname_click() {
		this.muVisible(false, "noname");
		this.ui.name.focus();
	}

	public name_keyup() { this.name_blur(); }

	public name_blur() {
		this.muVisible(!this.ui.name.innerText.trim(), "noname");
	} */

	public bAdd_click() {
		this.muWidgetFromTemplate("item", "items").muBindData({});
	}

	public bRemove_click() {
		const n = this.ui.name.innerText.trim();
		if (confirm("Opravdu chcete odebrat " + (n ? "skupinu " + n : "tuto skupinu") + "?")) this.muRemoveSelf();
	}

	public bUp_click() {
		changeElementOrder(this.container, -1);
	}

	public bDown_click() {
		changeElementOrder(this.container, 1);
	}

	public accountSelector_itemAdded(ev, item) {
		this.addApprover({
			name: item.name,
			accountId: item.id,
			type: "account"
		});
	}

	public orgRoleSelector_itemAdded(ev, item) {
		const newItem = {
			organizationApproverId: item.id,
			organizationApproverName: item.name,
			orgDivisionId: null,
			orgDivisionName: null,
			type: "orgRole"
		};
		if (this.ui.useOtherOrgDivision.checked) {
			//todo: type
			const nodes = (this.muNamedWidget.orgDivisionSelector as any).getSelectedNodes();
			const node = nodes.length ? nodes[0] : null;
			newItem.orgDivisionId = node.key;
			newItem.orgDivisionName = node.title;
		}
		this.addApprover(newItem);
	}

	private addApprover(item: any) {
		const field = item.type == 'orgRole' ? 'organizationApprover' : 'approver';
		const newItem = { ...item }
		// newItem[item.type + "Id"] = item.id;
		this.muWidgetFromTemplate(field, field + 's').muBindData(newItem);
	}

	public useOtherOrgDivision_change() {
		const useOther = this.ui.useOtherOrgDivision.checked;
		this.muVisible(useOther, "orgDivisionSelector");
		if (useOther) (this.muNamedWidget.orgDivisionSelector as any).openModal();
	}
}

export class ApprovingSchemaEditorApprover extends IMuWidget {
	private data: any;
	public type: "orgRole"|"account";
	protected muAfterBindData(data) {
		this.data = data;
		let n : string;
		switch (this.type) {
			case "orgRole":
				n = "Role " + data.organizationApproverName
					+ (data.orgDivisionId ? " pro organizační jednotku " + data.orgDivisionName : "");
				break;
			case "account":
				n = /* "Uživatel " + */data.name;
				break;
		}
		this.ui.displayName.innerText = n;
	}

	public muFetchData(): any {
		return this.data;
	}

	public bRemove_click() {
		if (confirm("Opravdu chcete odebrat schvalovatele " + this.ui.displayName.innerText + "?")) this.muRemoveSelf();
	}
}

export class ApprovingSchemaEditorListItem extends IMuWidget {
	muParent: ApprovingSchemas;

	public id : string;
	//todo: new mu widget
	bEdit_click(ev) : boolean {
		// this.muParent.openEditor(this.id);
		if (!isOpenInNew(ev)) {
			this.muParent.router.navigate('edit', {id: this.id});
			ev.preventDefault();
			return false;
		}
		return true;
	}
	name_click(ev: Event) {
		// this.muParent.openEditor(this.id);
		return this.bEdit_click(ev.target, ev);
	}
	bTry_click() {
		// this.muParent.openTry(this.id);
		this.muParent.router.navigate('try', {id: this.id});
	}

	async bRemove_click() {
		if (confirm("Opravdu mám smazat koncept " + this.ui.name.innerText + "?")) {
			await this.muParent.cl.removeDraft(this.id);
			this.muParent.openList();
		}
	}

	async bActivate_click() {
		await this.muParent.cl.setApprovingSchemaActive(this.id, true);
		this.muParent.openList();
	}

	async bDeactivate_click() {
		await this.muParent.cl.setApprovingSchemaActive(this.id, false);
		this.muParent.openList();
	}

	public muAfterBindData(data: any) {
		let icon = "";
		let state = "";
		this.muVisible(false, ["bRemove", "bActivate", "bDeactivate"]);
		if (data.id.toString().startsWith(ApprovingSchemas.draftPrefix)) {
			icon = "checked-off";
			this.ui.id.innerText = data.id.toString().substr(6);
			state = "Koncept";
			this.muVisible(true, "bRemove");
		} else if (data.active) {
			icon = "yes";
			state = "Aktivní"
			this.muVisible(true, "bDeactivate");
		} else {
			icon = "no";
			state = "Neaktivní"
			this.muVisible(true, "bActivate");
		}
		this.ui.icon.className = "icon-" + icon;
		this.ui.state.innerText = state;

	}

	getUrl(id, ev, name) : string {
		return this.muParent.router.makeUrl(name, {id: id});
	}
}

export class ApprovingSchemaTry extends IMuWidget {
	private schema: ApprovingSchema;
	muParent: ApprovingSchemas;
	private groupAccountIds: Record<number, number[]>;
	private accounts: Record<number, Account>;
	public doCheck : boolean;
	public bindSchema(schema : ApprovingSchema) {
		this.doCheck = false;
		this.schema = schema;
		this.groupAccountIds = {};
		this.accounts = {};
		let newGroupId = -1;
		for(const step of schema.steps) {
			for(const group of step.groups) {
				if (!group.id) group.id = newGroupId--;
			}
		}
		this.muBindData(schema);
	}

	afterIndex() {
		// odložit načtení ať se první načte seznam schémat
		setTimeout(() => {
			this.muParent.cl.getOrgDivisions().then(data => (this.muNamedWidget.orgDivision as TreeSelector).bindTree(data));
			this.muParent.cl.getOrgProjects().then(data => (this.muNamedWidget.orgProject as TreeSelector).bindTree(data));
		}, 100);
	}

	public getAccountsForGroupId(groupId : number) {
		if (this.groupAccountIds[groupId])
			return this.groupAccountIds[groupId].map(accountId => this.accounts[accountId]);
		return [ ];
	}

	public bTry_click() {
		this.doCheck = true;
		const orgDivisionId = parseInt((this.muNamedWidget.orgDivision as TreeSelector).getValue());
		const orgProjectId = parseInt((this.muNamedWidget.orgProject as TreeSelector).getValue());
		if (!orgDivisionId && !orgProjectId) {
			UiFlashMessage.instance.add("Je potřeba vybrat organizační jednotku a/nebo projekt.");
			return;
		}
		this.muParent.cl.getApproversForSchema(
			this.schema,
			orgDivisionId,
			orgProjectId
		).then((data) => {
			this.accounts = indexBy(data.accounts, 'id');
			this.groupAccountIds = data.groupAccountIds
			this.muBindData(this.schema);
		})
	}

	bClose_click() {
		this.muParent.openTry(false);
	}
}

export class ApprovingSchemaTryGroup extends IMuWidget {
	muParent: (IMuWidget & { muParent : ApprovingSchemaTry });
	protected muAfterBindData(data: any) {
		super.muAfterBindData(data);
		if (this.muParent.muParent.doCheck) {
			this.ui.name.className = "approving-schema-editor-group__name"
				+ (this.ui.approverAccounts.childElementCount < data.minimalApprovers ? "--invalid" : "--valid");
		}
	}
}
// export class Router extends Rou
